export default __webpack_public_path__ + "static/media/home_icon.7fe65034.svg";